import React from "react";
import { motion } from "framer-motion";
import { useLang } from "../../i18n/LanguageContext";
import { S } from "../../data/strings";
import { FEATURED } from "../../data/content";
import { SectionHead } from "./Ornament";
import { EASE } from "../../lib/motion";

export const Featured = () => {
  const { t } = useLang();
  return (
    <section data-testid="featured-section" className="bg-ivory grain relative py-24 sm:py-32">
      <div className="mx-auto max-w-[1400px] px-6 sm:px-10">
        <SectionHead overline={S.featured.overline} heading={S.featured.heading} />
        <div className="mt-16 grid grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
          {FEATURED.map((p, i) => (
            <motion.div
              key={p.name.en}
              data-testid={`featured-card-${i}`}
              className="group relative overflow-hidden rounded-lg border border-gold/15 aspect-[4/5]"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.1 }}
              transition={{ duration: 0.7, ease: EASE, delay: (i % 3) * 0.08 }}
            >
              <img
                src={p.img}
                alt={t(p.name)}
                loading="lazy"
                className="w-full h-full object-cover transition-transform duration-[1400ms] ease-out group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-burgundy/85 via-burgundy/10 to-transparent" />
              <div className="absolute inset-x-0 bottom-0 p-5">
                <span className="font-cinzel text-[9px] tracking-luxe uppercase text-goldlight">{t(p.tag)}</span>
                <h3 className="mt-1 font-serif text-lg sm:text-xl text-ivory leading-tight">{t(p.name)}</h3>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
